import React, { useState } from "react";
import api from "../../../data/api/mainApi";
import { saveAs } from "file-saver";
import { Link } from "react-router-dom";
import MillingContourEditor from "./MillingContourEditor";

export async function downloadDxf(key, name) {
  const { data } = await api.get(`/millings/dxf/${encodeURIComponent(key)}`, { responseType: "blob" });
  saveAs(data, `${(name || "minta").replace(/[<>:"/\\|?*]/g, "_")}.dxf`);
}

export default function DxfPicker({ value, onChange, disabled }) {
  const [error, setError] = useState("");
  const [downloading, setDownloading] = useState(false);
  return <div className="d-flex gap-2 align-items-center flex-wrap mt-3">
    <label>DXF-fájl (max. 500 MB)
      <input className="form-control" type="file" accept=".dxf" disabled={disabled}
        onChange={(event) => {
          const file = event.target.files[0]; event.target.value = "";
          if (!file) return;
          if (!file.name.toLowerCase().endsWith(".dxf") || file.size > 500 * 1024 * 1024) {
            setError("Legfeljebb 500 MB-os DXF-et válassz."); return;
          }
          setError(""); onChange({ ...value, dxfFile: file });
        }} />
    </label>
    {value.dxfFile && <span>{value.dxfFile.name}</span>}
    {(value.dxfKey || value.dxfFile) && <MillingContourEditor mode="dxf" value={value} onChange={onChange} disabled={disabled} />}
    {value.dxfKey && !value.dxfFile && !disabled && <Link to={`/milling-splitter?dxf=${encodeURIComponent(value.dxfKey)}`}>DXF darabolása</Link>}
    {value.dxfKey && !value.dxfFile && <button type="button" className="btn btn-outline-secondary btn-sm" disabled={disabled || downloading}
      onClick={async () => {
        setDownloading(true); setError("");
        try { await downloadDxf(value.dxfKey, value.name); } catch { setError("A DXF letöltése nem sikerült."); }
        finally { setDownloading(false); }
      }}>{downloading ? "Letöltés…" : "DXF letöltése"}</button>}
    {(value.dxfKey || value.dxfFile) && <button type="button" className="btn btn-outline-secondary btn-sm" disabled={disabled}
      onClick={() => onChange({ ...value, dxfKey: "", dxfFile: null })}>DXF eltávolítása</button>}
    {error && <span role="alert" className="text-danger">{error}</span>}
  </div>;
}
